import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledAuthWrapper = styled.div(
    ({theme: {palette, spacing}}) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        background-color: ${palette.neutral['50']};
        padding: ${spacing * 2}px;
    `
)

export const StyledAuthTitle = styled.h3(
    ({theme: {typography, palette}}) => css`
        ${typography.displaySm};
        font-weight: 500;
        color: ${palette.neutral[950]};
    `
)

export const StyledAuthSubtitle = styled.p(
    ({theme: {typography, palette}}) => css`
        ${typography.textMd};
        font-weight: 400;
        color: ${palette.neutral[600]};
        text-align: center;
    `
)

export const StyledAuthForm = styled(Flexbox)`
    position: relative;
    max-width: 390px;
`
